<div [ngClass]="footerClass">
  <ng-container *ngIf="!options.branding">
    <div class="ad-footer-logo"></div>
    <div class="ad-footer-line1">
      &copy; {{options?.copyRight.replace("[[year]]",currentYear)}}
    </div>
    <div class="ad-footer-line2">
      All Rights Reserved | Patent Pending
    </div>
    <div class="ad-footer-spaceLine">
      &nbsp;
    </div>
    <div class="ad-footer-line3">
      For technical support contact
    </div>
    <div class="ad-footer-line4">
      <span (click)="clickCorProSupportEmail($event)">
        {{ options?.email }}
      </span>
    </div>
    <div class="ad-footer-line5">
      <span (click)="clickCorProSupportPhone($event)">
        T: {{options?.phone}}
      </span>
    </div>
    <div class="ad-footer-line6">
      Hours of Operation: {{options?.opertionTime}}
    </div>
    <div class="ad-footer-spaceLine2">
      &nbsp;
    </div>
    <div class="ad-footer-line7">
      <span (click)="clickAlterDomus($event)">
        www.alterDomus.com
      </span>
    </div>
    <div class="ad-footer-spaceLine2">
      &nbsp;
    </div>
    <div class="ad-footer-line8">
      <div class="ad-footer-line8-left">
        <span (click)="clickPrivacyShieldNotice($event)">
          Privacy Statement
        </span>
      </div>
      <div class="ad-footer-line8-right">
        <div class="ad-footer-line8-right-logo"></div>
        <span>
          YOUR PARTNER FOR GROWTH
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="options.branding">
    <div class="ad-footer-default-branding">
      <div [innerHTML]="options.footerHtml">
      </div>
    </div>
  </ng-container>
</div>